import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setLanguage, type AdminLang } from "@/i18n/index";

const locales: Array<{ code: AdminLang; label: string }> = [
  { code: "sr", label: "SR" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language as AdminLang;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(e.target.value as AdminLang);
  };

  return (
    <div className="relative inline-flex items-center">
      <select
        value={current}
        onChange={handleChange}
        className="appearance-none bg-neutral-100 text-xs font-medium text-neutral-600 pl-2 pr-6 py-1 rounded cursor-pointer border-0 focus:outline-none focus:ring-1 focus:ring-primary-500"
      >
        {locales.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
      <ChevronDown className="w-3 h-3 text-neutral-400 absolute right-1.5 pointer-events-none" />
    </div>
  );
}
